import {fetchAuthSession} from '@aws-amplify/auth';
import {getUTMFromCookie} from '../utils/googleTagManager';


const ATTR_SAVED_KEY = 'lgc_attr_saved';

export async function saveAttributionAfterOAuth(): Promise<void> {
    if (localStorage.getItem(ATTR_SAVED_KEY)) return;

    const utm = getUTMFromCookie();
    if (!utm) return;

    try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        if (!token) return;

        const pgServerEndpoint = import.meta.env.VITE_APP_PM_SERVER_ENDPOINT;
        if (!pgServerEndpoint) return;

        const url = new URL(pgServerEndpoint);
        url.pathname = '/attribution';
        url.search = '';
        url.hash = '';

        await fetch(url.toString(), {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(utm),
        });

        localStorage.setItem(ATTR_SAVED_KEY, '1');
    } catch (e) {
        console.warn('[Auth] Failed to save UTM attribution after OAuth:', e);
    }
}
